import { Capacitor } from '@capacitor/core'
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings'

async function openAppSettings() {
  if (Capacitor.isNativePlatform()) {
    try {
      await NativeSettings.open({
        optionAndroid: AndroidSettings.ApplicationDetails,
        optionIOS: IOSSettings.App,
      })
    } catch (error) {
      console.error('Error opening app settings', error)
    }
  }
}

export { openAppSettings }
